import { Loader } from "@mantine/core";

const CustomLoader = () => (
  <div>
    <Loader /> Loading...
  </div>
);

export default CustomLoader;
